export class ParserOptions {
  static default: ParserOptions = new ParserOptions();
  parseSecureNotesToAccount = true;
}
